import styled from '@emotion/styled';
import { tokens, Text } from '@hotjar/hotsauce';
import { List as RawList, ListItem } from '@hotjar/webapp/components/List';

const Wrapper = styled.div`
  b {
    ${tokens.text('subtitle2')};
  }
`;

const List = styled(RawList)`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
`;

interface FeatureListProps {
  heading: JSX.Element;
  children: JSX.Element[];
}

export const FeatureList = ({ heading, children }: FeatureListProps): JSX.Element => {
  return (
    <Wrapper>
      <Text textType="body2" as="p" data-testid="post-install-card-plan-details">
        {heading}
      </Text>
      <List>
        {children.map((feature: JSX.Element, index: number) => (
          <ListItem key={feature.props.i18nKey || index}>{feature}</ListItem>
        ))}
      </List>
    </Wrapper>
  );
};
